module.exports = __webpack_public_path__ + "img/XT-ConsumiblesTipoTregaskiss.0e449de2.png";